/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDecreaseIndent = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 17v2H2v-2zM5.293 8.293l1.414 1.414L4.415 12l2.292 2.293-1.414 1.414L1.586 12zM22 13v2H9v-2zm0-4v2H9V9zm0-4v2H2V5z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgDecreaseIndent as DecreaseIndent };
